import { CSV, CSVIndex } from "../../../../library/ts/vanilla/text/CSV";
import { ISOTimeStamp } from "../../../../library/ts/vanilla/time/ISOTimeStamp";

export class SendJob
{
  language:string;
  emailType:string;
  email:string;
  name:string;
  key:string;
  reference:KeyReference;

  clone()
  {
    let clone = new SendJob();
    clone.language = this.language;
    clone.emailType = this.emailType;
    clone.email = this.email;
    clone.name = this.name;
    clone.key = this.key;
    clone.reference = this.reference;
    return clone;
  }
}


export class SendingKeyMap
{
  csv:CSV;
  savePath:string;
  usedKeys:Set<string> = new Set<string>();

  setUsed( index:CSVIndex )
  {
    this.usedKeys.add( index.hash );
  }

  markSent( sendJob:SendJob )
  {
    // Key,Name,Email,Date Sent,Language,Email Type

    let keyHeader = this.csv.find( "Key" );

    let nameRow    = this.csv.findRowOffset( keyHeader.line, "Name" );
    let emailRow   = this.csv.findRowOffset( keyHeader.line, "Email" );
    let dateSent   = this.csv.findRowOffset( keyHeader.line, "Date Sent" );
    let language   = this.csv.findRowOffset( keyHeader.line, "Language" );
    let emailType  = this.csv.findRowOffset( keyHeader.line, "Email Type" );

    let lineIndex = sendJob.reference.index.line;

    this.csv.set( lineIndex, nameRow, sendJob.name );
    this.csv.set( lineIndex, emailRow, sendJob.email );
    this.csv.set( lineIndex, dateSent, ISOTimeStamp.now().value );
    this.csv.set( lineIndex, language, sendJob.language );
    this.csv.set( lineIndex, emailType, sendJob.emailType );
    
  }

  findEmptyKeyIndex()
  {
    let keyHeader = this.csv.find( "Key" );
    let startLine = keyHeader.nextLine.line;
    
    let nameRow = this.csv.findRowOffset( keyHeader.line, "Name" );

    let index = new CSVIndex();

    for ( let i = startLine; i < this.csv.numLines; i++ )
    {
      let isEmpty = this.csv.get( i, nameRow ) === "";

      if ( ! isEmpty )
      {
        continue;
      }

      index.set( i, nameRow );

      if ( this.usedKeys.has( index.hash ) )
      {
        continue;
      }

      return index;

    }

    return null;
  }
}

export class KeyReference
{
  csv:CSV;
  index:CSVIndex;
}

export class SendJobs
{
  keyMaps:SendingKeyMap[] = [];
  jobs:SendJob[] = [];

  addKeys( keysList:CSV[] )
  {
    keysList.forEach(
      ( c )=>
      {
        let km = new SendingKeyMap();
        km.csv = c;
        this.keyMaps.push( km );
      }
    )
  };  

  addJob( job:SendJob )
  { 
    let reference = job.reference;
    this.jobs.push( job );
    let keyMap = this.keyMaps.find( km => km.csv === reference.csv );
    keyMap.setUsed( reference.index );
  }

  getSendingKeyMapFor( job:SendJob )
  {
    return this.keyMaps.find( km => km.csv === job.reference.csv );
  }

  markSent( job:SendJob )
  {
    let km = this.getSendingKeyMapFor( job )
    km.markSent( job );
  }

  findKey():KeyReference
  {
    for ( let km of this.keyMaps )
    {
      let emptyKeyIndex = km.findEmptyKeyIndex();

      if ( emptyKeyIndex != null )
      {
        let keyReference = new KeyReference();
        keyReference.csv = km.csv;
        keyReference.index = emptyKeyIndex;

        return keyReference;
      }
    }

    return null;
  }
}